import { Rap } from './api/raps/types';

export class LoginRequested {
  readonly type = 'LoginRequested';
}

export class LoggedIn {
  readonly type = 'LoggedIn';
}

export class LoginFailed {
  readonly type = 'LoginFailed';
  constructor(readonly reason: string) {}
}

export class RapsRequested {
  readonly type = 'RapsRequested';
}

export class RapsLoaded {
  readonly type = 'RapsLoaded';
  constructor(readonly raps: Rap[]) {}
}

export class AudioStreamRequested {
  readonly type = 'AudioStreamRequested';
  constructor(readonly rapId: string) {}
}

export class AudioStreamReceived {
  readonly type = 'AudioStreamReceived';
  constructor(readonly url: string) {}
}

export class RapUploadProgressed {
  readonly type = 'RapUploadProgressed';
  constructor(readonly progress: number) {}
}

export class RapUploadFailed {
  readonly type = 'RapUploadFailed';
  constructor(readonly reason: string) {}
}

export class RapUploaded {
  readonly type = 'RapUploaded';
  constructor(readonly rap: Rap) {}
}

export class FilterMenuToggled {
  readonly type = 'FilterMenuToggled';
}

export class FiltersApplied {
  readonly type = 'FiltersApplied';
  constructor(readonly ids: string[]) {}
}

export type Action = LoginRequested | LoggedIn  | LoginFailed | RapsRequested | RapsLoaded | AudioStreamRequested | AudioStreamReceived | RapUploadProgressed | RapUploadFailed | RapUploaded | FilterMenuToggled | FiltersApplied;

export class Actions {
  loginRequested = this.dispatcher(LoginRequested);
  loggedIn = this.dispatcher(LoggedIn);
  loginFailed = this.dispatcher(LoginFailed);
  rapsRequested = this.dispatcher(RapsRequested);
  rapsLoaded = this.dispatcher(RapsLoaded);
  audioStreamRequested = this.dispatcher(AudioStreamRequested);
  audioStreamReceived = this.dispatcher(AudioStreamReceived);
  rapUploadProgressed = this.dispatcher(RapUploadProgressed);
  rapUploaded = this.dispatcher(RapUploaded);
  rapUploadFailed = this.dispatcher(RapUploadFailed);
  filterMenuToggled = this.dispatcher(FilterMenuToggled);
  filtersApplied = this.dispatcher(FiltersApplied);

  constructor(private readonly dispatch: React.Dispatch<Action>) { }

  private dispatcher<T extends { new(...args: any[]): any }>(action: T) {
    return (...args: ConstructorParameters<T>) => { this.dispatch(new action(...args)); };
  }
}
